import NewChatEvent from './NewChatEvent';

export default class ChatTransferEvent extends NewChatEvent {}
